(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("color2name", [], factory);
	else if(typeof exports === 'object')
		exports["color2name"] = factory();
	else
		root["color2name"] = factory();
})(this, () => {
return 